<template>
    <modal
        id="work-orders-expense-accounts-modal"
        ok-title="Save"
        :title="modalTitle"
        :okDisabled="!meta.valid"
        :visible="showModal"
        @show="onShow"
        @hide="modalHide"
        @cancel="modalHide"
        @ok="onExpenseAccountSave"
    >
        <div>
            <b-row>
                <b-col md="2">
                    <label>Expense Account:</label>
                </b-col>
                <b-col>
                    <b-form-input
                        trim
                        disabled
                        id="work-orders-expense-account-number"
                        type="text"
                        v-model="number"
                        :state="!errors.number ? undefined : false"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        :style="{
                            'margin-bottom': '0.6rem',
                            display: errors.length ? 'block' : 'none',
                        }"
                    >
                        {{ errors.number }}
                    </b-form-invalid-feedback>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="2">
                    <label>Name:</label>
                </b-col>
                <b-col>
                    <b-form-input
                        trim
                        id="work-orders-expense-account-name"
                        type="text"
                        v-model="name"
                        :state="!errors.name ? undefined : false"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        :style="{
                            display: errors.name ? 'block' : 'none',
                        }"
                    >
                        {{ errors.name }}
                    </b-form-invalid-feedback>
                </b-col>
            </b-row>
        </div>
    </modal>
</template>

<script>
    import API from './../../../api';
    import Modal from '../../generic/modal/modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import { computed, onMounted } from 'vue';
    import { useForm } from 'vee-validate';

    const MODAL_TIMEOUT = 200;
    export default {
        name: 'ExpenseAccountModal',
        components: {
            Modal,
            FormInput,
        },
        props: {
            expenseAccount: {
                type: Object,
                default: null,
            },
            showModal: {
                type: Boolean,
                default: false,
            },
            modalType: {
                type: String,
                default: 'create',
            },
        },
        setup(props, { emit }) {
            const modalTitle = computed(() => {
                return props.modalType === 'create' ? 'Add Expense Account' : 'Edit Expense Account';
            });

            const { values, meta, errors, defineField, setValues } = useForm({
                validationSchema: {
                    number: 'required',
                    name: 'required',
                },
            });
            const [number] = defineField('number');
            const [name] = defineField('name');

            const isSaveDisabled = computed(() => {
                return Boolean(props.validationError);
            });

            const onShow = () => {
                setValues(props.expenseAccount);
            };

            const onExpenseAccountSave = () => {
                emit('save', { ...values });
            };

            const modalHide = () => {
                emit('modalHide');
            };

            return {
                modalTitle,
                isSaveDisabled,
                onExpenseAccountSave,
                modalHide,
                number,
                name,
                meta,
                errors,
                onShow,
            };
        },
    };
</script>

<style lang="scss" scoped></style>
